/**
 * Returns `undefined` when query parameter can't be read yet.
 *         `null` when query param is not present.
 *         Otherwise, the string value of the query param.
 */
export const getQueryParam = (queryParamKey: string): string | null | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  // We can't use router?.query.key because this does sometimes return undefined, which would fail the validation
  // window.location.search always contains all query params
  return new URLSearchParams(window.location.search).get(queryParamKey);
};

/**
 * Returns `undefined` when query parameter can't be read yet.
 *         `null` when query param is not present or invalid.
 *         Otherwise, the decoded string value of the query param.
 */
export const decodeBase64QueryParam = (queryParamKey: string): string | null | undefined => {
  const encoded = getQueryParam(queryParamKey);
  if (encoded === null || encoded === undefined) {
    return encoded;
  }
  try {
    return window.atob(encoded);
  } catch (e) {
    // happens when the param is not a valid Base64 string
    return null;
  }
};
